/**
 * Branch Web SDK - Shared Utilities
 * Common helpers and configuration for Branch event tracking
 */

(function() {
  'use strict';

  // Global configuration
  window.BranchConfig = {
    currency: 'INR',
    debug: true, // Set to false in production
    branchKey: 'key_live_lvAqMYFdtcsnliH49ZPkThdnFzl6HwZ0'
  };

  // Utility: Debounce function to prevent duplicate events
  window.BranchUtils = window.BranchUtils || {};

  window.BranchUtils.debounce = function(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // Utility: Safe Branch event logger with error handling
  window.BranchUtils.trackEvent = function(eventName, eventData) {
    try {
      if (typeof branch === 'undefined') {
        console.warn('Branch SDK not loaded yet');
        return;
      }

      branch.logEvent(
        eventName,
        eventData,
        function(err) {
          if (err) {
            console.error('Branch event error:', err);
          } else if (window.BranchConfig.debug) {
            console.log('✅ Branch event tracked:', eventName, eventData);
          }
        }
      );
    } catch (error) {
      console.error('Branch tracking error:', error);
    }
  };

  // Utility: Check if Branch SDK is ready
  window.BranchUtils.isBranchReady = function() {
    return typeof branch !== 'undefined' && branch.init;
  };

  // Utility: Wait for Branch SDK to be ready
  window.BranchUtils.whenBranchReady = function(callback, maxWait = 5000) {
    if (window.BranchUtils.isBranchReady()) {
      callback();
      return;
    }

    let elapsed = 0;
    const interval = 100;

    const checkInterval = setInterval(function() {
      elapsed += interval;

      if (window.BranchUtils.isBranchReady()) {
        clearInterval(checkInterval);
        callback();
      } else if (elapsed >= maxWait) {
        clearInterval(checkInterval);
        console.error('Branch SDK failed to load within timeout');
      }
    }, interval);
  };

  // Utility: Format Shopify price (cents to decimal)
  window.BranchUtils.formatPrice = function(priceInCents) {
    return parseFloat((priceInCents / 100).toFixed(2));
  };

  // Utility: Create Branch commerce data structure
  window.BranchUtils.createCommerceItem = function(item) {
    return {
      '$product_id': String(item.product_id || ''),
      '$product_name': item.product_title || item.title || '',
      '$product_variant': String(item.variant_id || item.id || ''),
      '$price': window.BranchUtils.formatPrice(item.price || 0),
      '$quantity': item.quantity || 1,
      '$sku': item.sku || '',
      '$product_brand': item.vendor || '',
      '$currency': window.BranchConfig.currency
    };
  };

  if (window.BranchConfig.debug) {
    console.log('🔧 Branch Utils initialized');
  }

})();
